



















import { Vue, Component, Prop } from "vue-property-decorator";
const keys = {
  body: "page-body",
  attr: "data-scroll-top",
};
@Component({
  name: "pageFrame",
})
export default class extends Vue {
  @Prop()
  headStyle?: String;

  @Prop()
  bodyStyle?: String;

  @Prop()
  footStyle?: String;

  //data

  activated() {
    var elBody = this.$refs[keys.body] as any;
    let scrollTop = elBody.getAttribute(keys.attr);
    elBody.scrollTop = scrollTop || 0;
  }

  deactivated() {
    var elBody = this.$refs[keys.body] as any;
    elBody.setAttribute(keys.attr, elBody.scrollTop);
  }
}
